// let admin = require("firebase-admin");

// let serviceAccount = require("path/to/serviceAccountKey.json");

// admin.initializeApp({
//   credential: admin.credential.cert(serviceAccount),
//   databaseURL: "https://reflective-learning-dashboard.firebaseio.com"
// });

export const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

export const firebaseLearnerConfig = {
  apiKey: process.env.VUE_APP_LEARNER_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_LEARNER_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_LEARNER_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_LEARNER_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_LEARNER_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_LEARNER_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.VUE_APP_LEARNER_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_LEARNER_FIREBASE_MEASUREMENT_ID
};
